import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../App";
import CheckToken from "../../_Login/CheckToken";
import useInvoke from "../../Tools/Invoker";
import TestSave from "../Tools/OilerTestSave";
import toast from "react-hot-toast";

const OilerConfigurationTests = () => {
    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();
    const { id } = useParams();
    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });

    const [tests, setTests] = useState([]);

    const response94 = useInvoke("WebApps", "94", { "@ConfigID": id });

    useEffect(() => {
        if (response94.data.payload !== undefined) {
            const myTests = JSON.parse(response94.data.payload).data;
            let testsList = [];

            myTests.forEach(test => {
                let obj = {
                    TestID: test[0],
                    ConfigID: test[1],
                    TestNum: test[2],
                    BlankNum: test[3],
                    TopValue: test[4],
                    BottomValue: test[5],
                    Position: test[6]
                };

                testsList.push(obj);
            });

            // Sort the tests
            testsList.sort((a, b) => {
                if (a.BlankNum !== b.BlankNum) {
                    return a.BlankNum - b.BlankNum;
                } else if (a.Position !== b.Position) {
                    return a.Position.localeCompare(b.Position);
                } else {
                    return a.TestNum - b.TestNum;
                }
            });

            setTests(testsList);
        }
    }, [response94.data.payload]);

    const handleUpdateTest = (testid, configid, testnum, blanknum, topvalue, bottomvalue, position) => {
        let topValueElement = document.getElementById(`top-value-${testid}`);
        let bottomValueElement = document.getElementById(`bottom-value-${testid}`);
        if (topValueElement.defaultValue === topvalue && bottomValueElement.defaultValue === bottomvalue) {
            return;
        }

        let newTests = tests.map(test => {
            if (test.TestID === testid) {
                return {
                    ...test,
                    TopValue: topvalue,
                    BottomValue: bottomvalue
                };
            } else {
                return test;
            }
        });

        setTests(newTests);

        toast.promise(
            TestSave(testid, configid, testnum, blanknum, topvalue, bottomvalue, position),
            {
                loading: "Updating test...",
                success: `${position} Blank ${blanknum} Test ${testnum} updated`,
                error: "Error updating test"
            },
            {
                position: "bottom-center"
            }
        );
    };

    const getTestsByPositionAndBlankNum = (position, blankNum) => {
        return tests.filter(test => test.Position === position && test.BlankNum === blankNum);
    };

    const renderTestTable = (tests, position, blankNum) => (
        <>
            {tests.length > 0 && (
                <div style={{ width: "48%", display: "flex", flexDirection: "column", margin: "1%" }}>
                    <h3>{position} Position - Blank {blankNum}</h3>
                    <table className="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>Test #</th>
                                {tests.map((test, index) => (
                                    <th key={index} style={{ textAlign: "center" }}>{test.TestNum}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ verticalAlign: "middle", textAlign: "center", backgroundColor: "var(--bs-gray-200)" }}>Top (mg/sqft)</td>
                                {tests.map((test, index) => (
                                    <td key={index} style={{ textAlign: "center", backgroundColor: test.BlankNum % 2 === 0 ? "var(--bs-gray-100)" : "var(--bs-gray-200)" }}>
                                        <input
                                            type="number"
                                            id={`top-value-${test.TestID}`}
                                            defaultValue={test.TopValue}
                                            style={{ textAlign: "center", width: "64px" }}
                                            onBlur={(e) => handleUpdateTest(test.TestID, test.ConfigID, test.TestNum, test.BlankNum, e.target.value, test.BottomValue, test.Position)}
                                        />
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <td style={{ verticalAlign: "middle", textAlign: "center", backgroundColor: "var(--bs-gray-200)" }}>Bottom (mg/sqft)</td>
                                {tests.map((test, index) => (
                                    <td key={index} style={{ textAlign: "center", backgroundColor: test.BlankNum % 2 === 0 ? "var(--bs-gray-100)" : "var(--bs-gray-200)" }}>
                                        <input
                                            type="number"
                                            id={`bottom-value-${test.TestID}`}
                                            defaultValue={test.BottomValue}
                                            style={{ textAlign: "center", width: "64px" }}
                                            onBlur={(e) => handleUpdateTest(test.TestID, test.ConfigID, test.TestNum, test.BlankNum, test.TopValue, e.target.value, test.Position)}
                                        />
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
        </>
    );

    document.title = "Oiler Configuration Tests";
    return (
        <>
            {user.email && (
                <div className="container body-content" style={{ marginTop: "25px" }}>
                    <div style={{ display: "flex", flexDirection: "row", marginBottom: "8px", justifyContent: "space-between" }}>
                        <Link to={`/Oilers/Configuration/${id}`} className="btn btn-default" style={{ marginRight: "4px", width: "auto" }}>Back</Link>
                    </div>

                    <h2>
                        Edit Tests for Configuration # {id}
                    </h2>

                    <div className="alert alert-info" role="alert">
                        <p>
                            Update the top and bottom values for each test. Click outside of the input box to save the changes. Values will be stored as whole numbers.
                        </p>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", flexWrap: "wrap", justifyContent: "center" }}>
                        {[...new Set(tests.map(test => test.BlankNum))].map(blankNum => (
                            <>
                                {renderTestTable(getTestsByPositionAndBlankNum("Left", blankNum), "Left", blankNum)}
                                {renderTestTable(getTestsByPositionAndBlankNum("Center", blankNum), "Center", blankNum)}
                                {renderTestTable(getTestsByPositionAndBlankNum("Right", blankNum), "Right", blankNum)}
                            </>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default OilerConfigurationTests;
